import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';
import { RubricPiiScanRequest, RubricPiiScanResponse } from '../../models';

export const scanRubricPii: (
  fetchContext: FetchContext,
  text: string,
  accessToken?: string,
) => Promise<RubricPiiScanResponse> = (fetchContext, text, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/staff/rubric/pii-scan`, {
    method: 'POST',
    body: JSON.stringify({ text } satisfies RubricPiiScanRequest),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<RubricPiiScanResponse>(fetchContext.errorStore, response, 'scan rubric for PII'));
